export * from './tabs/tabs.component';
